import { FieldStatus } from "../../types/FieldStatuses";
import { DocFieldConfig } from "../config/DocFieldConfig";
import { MatcherFactory } from "../matchers/factory/MatcherFactory";
import { BaseField } from "./BaseField";

export { ExtractedData };

/**
 * Store the returned extraction results for a DLF, and cache matcher extractions to
 * avoid slow API calls.
 */
abstract class ExtractedData<K, R = K, Z = R> {
  protected name: string;
  protected index: number = 0;

  extraction: K | undefined;
  /**
   * Key is the matchers UniqueId. This Id is unique between Matchers of different types
   */
  _reuse: Array<R | undefined>;

  /**
   * Store each matcher ID against an extraction result.
   */
  _reuseCache: {
    [x in string]: Z;
  };

  constructor(name: string, extraction: K | undefined, reuse: R[]) {
    this.name = name;
    this.extraction = extraction;
    this._reuse = [];
    this._reuseCache = {};

    this.setReuse(reuse);

    if (this.put(this.extraction)) {
      // this.index = -1;
    } else {
      // this.index = this._reuse.length > 0 ? this. : 0;
    }
  }

  /**
   * Convert extracted entry K to reuse result R
   * @param entry
   */
  abstract extractToReuse(entry: K | R | undefined): R | undefined;

  /**
   * insert an extraction into the reuse cache.
   * @param entry entry
   * @returns true if cached
   */
  abstract put(entry: K | R | undefined): boolean;

  get reuse(): Array<R | undefined> {
    return [this.extractToReuse(this.extraction)].concat(
      this._reuse.filter((x) => x != undefined) as any,
    ) as Array<R | undefined>;
  }

  getName(): string {
    return this.name;
  }

  getAtIndex(): R | undefined {
    return this.reuse[this.index];
  }

  getExtracted(): K | undefined {
    return this.extraction;
  }

  getReuseAt(idx: number): R | undefined {
    // idx -= 1; // accomodate extraction = 0

    if (idx < 0) {
      idx = this.reuse.length - 1;
      // wrap around
    } else if (idx >= this.reuse.length) {
      // wrap around
      idx = 0;
    }
    return this.reuse[idx];
  }

  setIndex(index: number) {
    console.log(
      `ExtractedData(${this}) setting index to ${index} from ${this.index}`,
    );
    // TODO: deduplicate from getReuseAt()
    if (index < 0) {
      index = this.reuse.length - 1;
      // wrap around
    } else if (index >= this.reuse.length) {
      // wrap around
      index = 0;
    }
    this.index = index;
    console.log(`ExtractedData(${this}) set index to ${this.index}`);
  }

  /**
   * Cache the current BaseField and Matcher, update the extraction property
   * @param extraction
   * @param justAdd
   */
  setExtracted(extraction: K) {
    console.log(
      `ExtractedData(${this}) setting extraction to ${extraction} from index ${this.index}`,
    );
    this.put(this.extraction);
    this.extraction = extraction;
    this.index = 0;
  }

  clearExtracted() {
    this.extraction = undefined;
  }

  getReuse(): Array<R | undefined> {
    return this.reuse;
  }

  setReuse(reuseResults: Array<R>) {
    this._reuse = reuseResults;
  }

  /**
   * return 0 for extracted, or the index in reuse + 1
   */
  getIndex(): number {
    return this.index;
  }
}
